import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Posts from './components/Posts';
import HowToBuy from './components/HowToBuy';
import Roadmap from './components/Roadmap';
import Community from './components/Community';
import Footer from './components/Footer';
import GoldParticles from './components/GoldParticles';

function App() {
  return (
    <div className="App">
      <GoldParticles />
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <Posts />
      <HowToBuy />
      <Roadmap />
      <Community />
      <Footer />
    </div>
  );
}

export default App;
